import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";
export const TABLE_COLUMNS = [
  {
    Header: "Variable Name",
    accessor: "columnName",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Variable Value",
    accessor: "columnValue",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },
];
